import React from 'react';

const CajaInfo = ({ totalEnCaja, maxCajaAmount, excessAmount, alertVisible }) => (
  <div className="bg-gray-800 bg-opacity-40 rounded-lg p-3 md:p-4 border border-gray-700 space-y-2 md:space-y-3">
    <h3 className="text-base md:text-lg font-medium text-gray-200">
      Monto actual en caja: <span className="text-white font-semibold">${totalEnCaja}</span>
    </h3>
    <h3 className="text-base md:text-lg font-medium text-gray-200">
      Monto máximo permitido en caja: <span className="text-white font-semibold">${maxCajaAmount}</span>
    </h3>
    {alertVisible && (
      <div className="mt-3 md:mt-4 space-y-2">
        <h3 className="text-base md:text-lg font-bold text-red-400">
          Exceso de monto en caja: ${excessAmount}
        </h3>
        <div className="p-3 md:p-4 bg-gradient-to-r from-red-600 to-red-500 text-white text-center rounded-md border border-red-400 shadow-md text-sm md:text-base">
          <strong>⚠ Alerta:</strong> El monto en caja supera el límite permitido.
          Es necesario hacer un retiro de dinero.
        </div>
      </div>
    )}
  </div>
);

export default CajaInfo;
